import { enableProdMode, importProvidersFrom } from '@angular/core';

import {
  DatePipe,
  HashLocationStrategy,
  LocationStrategy,
  NgOptimizedImage,
  registerLocaleData,
} from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import zh from '@angular/common/locales/zh';
import { FormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFlexDirective } from 'ng-zorro-antd/flex';
import { NZ_I18N, zh_CN } from 'ng-zorro-antd/i18n';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { start as singleSpaStart } from 'single-spa';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CoreModule } from './app/core/core.module';
import { IconsProviderModule } from './app/icons-provider.module';
import { SharedModule } from './app/shared/shared.module';
import { XiaohongInterceptorService } from './app/xiaohong-interceptor.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(zh);

singleSpaStart();

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      IconsProviderModule,
      NzLayoutModule,
      NzMenuModule,
      NzModalModule,
      NzSelectModule,
      NzButtonModule,
      CoreModule,
      SharedModule,
      NgOptimizedImage,
      NzFlexDirective
    ),
    { provide: NZ_I18N, useValue: zh_CN },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XiaohongInterceptorService,
      multi: true,
    },
    provideAnimations(),
  ],
})
  .then((_module) => {
    // @ts-ignore
    window.isInSingleSpaApp = true;
  })
  .catch((err) => console.error(err));
